import RestAdapter from "discourse/adapters/rest";

export default class CircleAdapter extends RestAdapter {
  primaryKey = "category_id";

  appendQueryParams(path, findArgs, extension = ".json") {
    if (typeof findArgs === "string" && findArgs.indexOf("/") > 0) {
      return super.appendQueryParams(`${path}/${findArgs}`, "", extension);
    }

    return super.appendQueryParams(path, findArgs, extension);
  }
}
